// import ApplyOfficeHoursToQueue from "V2.0/HomePages/Assistants/AssistantSettings/CommunicationQueue/ApplyOfficeHoursToQueue";
import ActiveCallsStats from "./ActiveCalls";
import ProcessedCallsStats from "./ProcessedCalls";

export default function CallQueueStatsV2(props) {
  const {
    workspaceId,
    assistantId,
    syncAssistant,
    communicationQueueSettings,
    locked,
  } = props;
  return (
    <div className="flex flex-col gap-y-4">
      <div className="pt-2">
        <p className="font-semibold text-md">Call Queue</p>
      </div>
      {/* <ApplyOfficeHoursToQueue
        workspaceId={workspaceId}
        assistantId={assistantId}
        syncAssistant={syncAssistant}
        communicationQueueSettings={communicationQueueSettings}
        locked={locked}
      /> */}
      <ActiveCallsStats
        workspaceId={workspaceId}
        assistantId={assistantId}
        locked={locked}
      />
      <ProcessedCallsStats
        workspaceId={workspaceId}
        assistantId={assistantId}
      />
    </div>
  );
}
